import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserStore } from '@core/stores/user.store';

@Injectable({
  providedIn: 'root',
})
export class LogoutRedirectService {
  constructor(
    private router: Router,
    private readonly userStore: UserStore,
  ) {}

  public logoutAndRedirect(): void {
    localStorage.removeItem('token');
    this.userStore.set(null);
    this.router.navigate(['/sign-in']);
  }
}
